import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Avatar,
  Typography,
  Box,
  Chip,
  Button
} from '@mui/material';
import { Business, Person } from '@mui/icons-material';
import { styled } from 'styled-components';
import { useTranslation } from '../../commons/useTranslasion';
import { IAuth } from '../../commons/types/usuatios';

interface DialogSelecaoUnidadeOperacionalProps {
  open: boolean;
  usuarios: IAuth[];
  onUsuarioSelect: (usuario: IAuth) => void;
  onCancel: () => void;
}

const DialogSelecaoUnidadeOperacional: React.FC<DialogSelecaoUnidadeOperacionalProps> = ({
  open,
  usuarios,
  onUsuarioSelect,
  onCancel
}) => {
  const { translate } = useTranslation();

  return (
    <StyledDialog
      open={open}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 3,
          minHeight: '400px',
          background: 'linear-gradient(45deg, #64686e 0%, #c3cfe2 50%)'
        }
      }}
    >
      <DialogTitle>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Avatar sx={{ width: 64, height: 64, bgcolor: 'primary.main' }}>
            <Business fontSize="large" />
          </Avatar>
          <Typography variant="h5" component="h2" textAlign="center" color="white">
            {translate('selecionePrograma')}
          </Typography>
          <Typography variant="body1" textAlign="center" color="rgba(255,255,255,0.8)">
            {translate('voceTemMultiplosProgramas')}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={3} justifyContent="center" sx={{ mt: 1 }}>
          {usuarios.map((usuario, index) => (
            <Grid item xs={12} sm={6} md={4} key={usuario.id || index}>
              <StyledCard onClick={() => onUsuarioSelect(usuario)}>
                <CardActionArea>
                  <StyledCardContent>
                    <Avatar sx={{ width: 64, height: 64, mb: 2, bgcolor: 'primary.main' }}>
                      <Business fontSize="large" />
                    </Avatar>
                    
                    <Typography variant="h5" component="h3" gutterBottom textAlign="center" fontWeight="bold">
                      {usuario.comanda?.plano || 'Plano não informado'}
                    </Typography>
                    
                    <Typography variant="body1" color="text.secondary" mb={2} textAlign="center">
                      {usuario.nomeUnidadeOperacional || 'Unidade Operacional'}
                    </Typography>
                    
                    <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                      <Person fontSize="small" />
                      <Typography variant="body2" color="text.secondary">
                        {usuario.nome}
                      </Typography>
                    </Box>
                  </StyledCardContent>
                </CardActionArea>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 3, justifyContent: 'center' }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          sx={{
            color: 'white',
            borderColor: 'rgba(255,255,255,0.5)',
            '&:hover': {
              borderColor: 'white',
              backgroundColor: 'rgba(255,255,255,0.1)'
            }
          }}
        >
          {translate('cancelar')}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    background: linear-gradient(45deg, #64686e 0%, #c3cfe2 50%);
  }
`;

const StyledCard = styled(Card)`
  height: 200px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  border-radius: 12px;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    
    .MuiCardContent-root {
      color: white;
    }
    
    .MuiTypography-colorTextSecondary {
      color: rgba(255, 255, 255, 0.8) !important;
    }
  }
`;

const StyledCardContent = styled(CardContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
`;

export default DialogSelecaoUnidadeOperacional;
